import React from "react";
import Contacts from "../Apm/Contact/Contacts";

const ContactsPage = () => {
  return (
    <React.Fragment>
      <Contacts />
    </React.Fragment>
  );
};

export default ContactsPage;
